var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('emc-button-icon',{attrs:{"color":_vm.color,"icon":_vm.icon},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.download(_vm.report)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }